import { axiosWithAuth } from "helpers";

export const installationQueueService = {
	getInstallationList,
	assignApplication,
	unassignApplication,
	getAssignedTo,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getAssignedTo(pattern, page, showInactive = false) {
	const body = {
		pattern,
		page,
		pageSize: 20,
		showInactive,
	};

	const options = {
		method: "POST",
		data: body,
		url: `${API_URL}/api/applications/installation_queue/users`,
	};

	return axiosWithAuth(options);
}

async function getInstallationList({ tab, page, filters, sortBy }) {
	const options = {
		url: `${API_URL}/api/applications/installation_queue/${tab}`,
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			sort_type: sortBy?.id || undefined,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
			...filters,
			agent_office: filters?.agentOffice,
			agent_name: filters?.agentName,
			pend_status: filters?.pendStatus?.value,
			installation_assignee_id: filters?.assignedTo?.id,
			pended_to_id: filters?.pendedTo?.id,
			installation_outcome: filters?.installation_outcome?.name,
		},
	};

	delete options.params.pendedTo;
	delete options.params.assignedTo;
	delete options.params.pendStatus;
	delete options.params.agentOffice;
	delete options.params.agentName;

	return axiosWithAuth(options);
}

async function assignApplication(applicationId) {
	const options = {
		url: `${API_URL}/api/applications/installation_queue/${applicationId}/assign`,
		method: "POST",
	};

	return axiosWithAuth(options);
}

async function unassignApplication(applicationId) {
	const options = {
		url: `${API_URL}/api/applications/installation_queue/${applicationId}/unassign`,
		method: "POST",
	};

	return axiosWithAuth(options);
}
